/**
 * enum to maintain the keys used by to the app to store data in local/session storage.
 */
export enum StorageKeys {
  /**
   * The key used to store the origin of the auto login request.
   * Used to redirect the user back on logout.
   * Need to cleat the storage on logout.
   */
  AUTO_LOGIN_ORIGIN_KEY = 'auto-login-origin',

  /**
   * Key used to store the all product search
   */
  PAST_SEARCHES = 'searches',

  /**
   * The key used to store whether the user is in impersonating state.
   * Need to cleat the storage on logout.
   */
  AUTO_LOGIN_IMPERSONATION_KEY = 'auto-login-impersonated',

  /**
   * Key used to store the order confirmation.
   */
  ORDER_CONFIRMATION_KEY = 'order-confirmation-data',

  SALESPAD_KEY = 'is-salespad-user',

  CXMLDETAILS_KEY = 'cxmlDetails',
  CONDENSEDVIEW_KEY = 'isCondensedView',

  /**
   * Url to navigate post login.
   */
  POST_LOGIN_REDIRECT = 'post-login-redirect',

  /**
   * Used to store the salespad user session before impersonating an org.
   */
  BACKED_UP_SESSION = 'backed-up-session',

  /**
   * Saved vehicle data related to CCL.
   */
  SAVED_VEHICLE_REGION_ID = 'savedVehicleData',

  /**
   * Scroll to product position when navigating back to results page .
   */
  SCROLL_TO_PRODUCTKEY = 'scrollToProductKey',

  /**
   * Save selected CGP data.
   */
  SELECTED_PARTS_CATALOG_KEY = 'selected_parts_catalog_key',

  /**
   * Persist multi-part inquiry "Copy line code from previous row" toggle.
   */
  COPY_LINE_CODE_FROM_PREVIOUS_ROW = 'copy-line-code-from-previous-row',
}

export const VITE_EXPERIAN_AUTOCHECK_BASE_URL =
  'https://www.autocheck.com/vehiclehistory/?siteID=7500'

export const SENTRY_DSN =
  'https://8508dada5dc4613c5e779662a4077beb@o4505784096391168.ingest.sentry.io/4505786669924352'

export const LISTS_IMPORT_RETRIES_LIMIT = 600000 // 10 mins in milliseconds
export const LISTS_IMPORT_RETRIES_INTERVAL = 2500 // 2.5 seconds in milliseconds
export const GENERAL_RETRIES_LIMIT = 600000 // 10 mins in milliseconds
export const GENERAL_RETRIES_INTERVAL = 2500 // 2.5 seconds in milliseconds
export const UPDATE_CHECK_INTERVAL = 900000 // 15 mins in milliseconds

/**
 * Batch size to pass to the sellnetwork.
 */
export const SELL_NETWORK_BATCH_SIZE = 30

export const categoriestoExclude: string[] = ['-Stock-', 'General']

export const ABSOLUTE_MAX_QUANTITY = 999

export const CART_VERSION_STRING = '1.1.1'

export const HAWK_SITE_TYPE = 'MyPlace'

export const MY_PLACE_SELLER = {
  id: 0,
  serviceDealerId: 0,
  coverageId: 0,
  coverageKey: '',
  isPrimary: false,
  regionId: 0,
  regionName: '',
  customerNumber: '',
  sellPartnerId: '',
  supEntityId: 0,
  sellerName: 'MyPlace4Parts',
  mailAddress: '',
  mailCity: '',
  mailState: '',
  mailPostalCode: '',
  mailCountryCode: '',
  mailCountry: '',
  contactName: '',
  emailAddress: '',
  phone: '',
  status: false,
  sequence: 0,
  logoUrl:
    'https://staging-myplace4parts.s3.amazonaws.com/ShareHolderLogos/4804/53955/53955.png',
  selected: true,
  storeName: '',
}
